import { render } from "./el_tabs_password.vue?vue&type=template&id=4565fa45&scoped=true"
import script from "./el_tabs_password.vue?vue&type=script&lang=js"
export * from "./el_tabs_password.vue?vue&type=script&lang=js"

import "./el_tabs_password.vue?vue&type=style&index=0&id=4565fa45&lang=less&scoped=true"

import exportComponent from "D:\\work_zfb\\zoudulaocheng\\web-zdlc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4565fa45"]])

export default __exports__